var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      ref: "headerRef",
      class: { "app-header": true, navbar: true },
      style: { top: _vm.tdbHeight + "px" }
    },
    [
      _c("b-link", { staticClass: "navbar-brand", attrs: { to: "/#/" } }),
      _vm._v(" "),
      _c("UserContext"),
      _vm._v(" "),
      _c(
        "b-navbar-nav",
        { staticClass: "headerNavRight d-md-down-none" },
        [
          _vm.authUser.isSuperAdmin
            ? _c(
                "b-nav-item-dropdown",
                { staticClass: "px-3", attrs: { text: "Admin", right: "" } },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "px-3 radiusT-10",
                      attrs: {
                        tag: "b-dropdown-item",
                        to: { path: "/admin/users" }
                      }
                    },
                    [_vm._v("\n        Users\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "px-3",
                      attrs: {
                        tag: "b-dropdown-item",
                        to: { path: "/admin/organizations" }
                      }
                    },
                    [_vm._v("\n        Organizations\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "px-3",
                      attrs: {
                        tag: "b-dropdown-item",
                        to: { path: "/admin/groups" }
                      }
                    },
                    [_vm._v("\n        Groups\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "px-3 radiusB-10",
                      attrs: {
                        tag: "b-dropdown-item",
                        to: { path: "/admin/logs" }
                      }
                    },
                    [_vm._v("\n        Logs\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-nav-item-dropdown",
            {
              ref: "parentDropdown",
              staticClass: "px-3",
              attrs: { text: "Data", right: "" },
              on: { hide: _vm.hideParentDropdown }
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "px-3 radiusT-10",
                  attrs: { tag: "b-dropdown-item", to: { path: "/statistics" } }
                },
                [_vm._v("\n        Statistics\n      ")]
              ),
              _vm._v(" "),
              _vm.authUser.isSuperAdmin
                ? _c(
                    "router-link",
                    {
                      staticClass: "px-3",
                      attrs: {
                        tag: "b-dropdown-item",
                        to: { path: "/globalreport" }
                      }
                    },
                    [_vm._v("\n        Global Reports\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.authUser.isSuperAdmin || _vm.isOrgManagerOrAdmin
                ? _c(
                    "b-dropdown-item",
                    {
                      staticClass: "px-3",
                      attrs: { tag: "b-dropdown-item" },
                      on: { click: _vm.downloadUserReportsByOrg }
                    },
                    [_vm._v("\n        Download User Reports\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isUserInLA
                ? _c(
                    "b-dropdown",
                    {
                      ref: "nestedDropdown",
                      staticClass: "header-dropdown-item px-3 radius-0-0-0-10",
                      attrs: { text: "Annual Data", dropright: "" },
                      on: {
                        hide: _vm.hideNestedDropdown,
                        show: function($event) {
                          _vm.isAnnualDataDropdownVisible = true
                        }
                      }
                    },
                    _vm._l(_vm.annualDataYears, function(year, i) {
                      return _c(
                        "router-link",
                        {
                          key: i,
                          class: {
                            "radiusT-10": i === 0,
                            "radiusB-10": i === _vm.annualDataYears.length - 1
                          },
                          attrs: {
                            tag: "b-dropdown-item",
                            to: { path: "/reviewannualdata/" + year }
                          }
                        },
                        [_vm._v("\n          " + _vm._s(year) + "\n        ")]
                      )
                    }),
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-nav-item-dropdown",
            { staticClass: "px-3", attrs: { text: "Help", right: "" } },
            [
              _c(
                "b-dropdown-item",
                {
                  staticClass: "px-3 radiusT-10",
                  attrs: {
                    target: "_blank",
                    href:
                      "https://share.hsforms.com/1bLyB7vWCRra3LjVUBn_qqA2gbug"
                  }
                },
                [_vm._v("\n        Submit Feedback\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  staticClass: "px-3",
                  attrs: {
                    target: "_blank",
                    href: "https://alliesagainstslavery.org/lighthouse-support/"
                  }
                },
                [_vm._v("\n        Support\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  staticClass: "px-3",
                  attrs: {
                    target: "_blank",
                    href:
                      "https://lighthouse-pdf-images.s3-us-west-2.amazonaws.com/WCC.CSE-IT.2.0.pdf"
                  }
                },
                [_vm._v("\n        View CSE-IT Form\n      ")]
              ),
              _vm._v(" "),
              _vm.isUserInLA
                ? _c(
                    "b-dropdown-item",
                    {
                      staticClass: "px-3",
                      attrs: {
                        target: "_blank",
                        href:
                          "https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/LT+Identification+Tool+FINAL.pdf"
                      }
                    },
                    [_vm._v("\n        View Labor Screening\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isUserInLA
                ? _c(
                    "b-dropdown-item",
                    {
                      staticClass: "px-3",
                      attrs: {
                        target: "_blank",
                        href:
                          "https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/LT+Identification+Tool+Supplementary+Guide+FINAL.pdf"
                      }
                    },
                    [_vm._v("\n        Labor Screening Guide\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isUserInLA
                ? _c(
                    "b-dropdown-item",
                    {
                      staticClass: "px-3",
                      attrs: {
                        target: "_blank",
                        href:
                          "https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/Louisiana.Sex.Trafficking.Tool_Final.Draft.2.pdf"
                      }
                    },
                    [_vm._v("\n        View LA Sex Trafficking Tool\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isUserInLA
                ? _c(
                    "b-dropdown-item",
                    {
                      staticClass: "px-3 radiusB-10",
                      attrs: {
                        target: "_blank",
                        href:
                          "https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/Supplementary.User.Guide_LSTTpdf.1.pdf"
                      }
                    },
                    [
                      _vm._v(
                        "\n        LA Sex Trafficking Tool User Guide\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.$auth.ready()
            ? _c(
                "b-nav-item",
                { staticClass: "px-3 nav-logout", on: { click: _vm.logout } },
                [
                  _vm._v("Log Out "),
                  _c("img", {
                    staticStyle: { "margin-left": "16px" },
                    attrs: {
                      src: require("../../../static/img/logout.png"),
                      width: "16.63px",
                      height: "17px"
                    }
                  })
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-741978ef", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-741978ef","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Header.vue
// module id = 1425
// module chunks = 0